import { defineComponent as F, ref as C, watch as T, onMounted as D, nextTick as q, onUnmounted as G, computed as K, openBlock as l, createElementBlock as x, normalizeClass as c, createCommentVNode as v, Fragment as L, renderList as H, createBlock as S, resolveDynamicComponent as A, mergeProps as y, unref as J, withKeys as V, withCtx as O, renderSlot as Q, createTextVNode as R, toDisplayString as W, createElementVNode as N, normalizeStyle as U } from "vue";
function X(f, k) {
  let t = !1;
  return function() {
    t || (f(), t = !0, setTimeout(function() {
      t = !1;
    }, k));
  };
}
class j {
  constructor() {
    this.defaultPrevented = !1;
  }
  preventDefault() {
    this.defaultPrevented = !0;
  }
}
const g = {
  default: {
    classes: {
      wrapper: "p-[4px] inline-flex gap-[4px] rounded border border-gray-100 bg-white text-gray-700 relative",
      button: "flex items-center px-[12px] h-[24px] leading-[20px] text-[14px] rounded font-medium whitespace-nowrap bg-transparent border-0",
      active: "text-black relative z-20",
      activeStatic: "!text-white",
      inActive: "hover:bg-gray-50",
      activeMarker: "absolute bottom-[4px] top-[4px] rounded duration-300 ease-in-out",
      activeMarkerColor: "bg-indigo-500 filter hue-rotate-180 brightness-200 saturate-150 z-10",
      activeMarkerBlender: "z-30 bg-white mix-blend-difference pointer-events-none",
      activeMarkerStatic: "bg-indigo-500 absolute -z-10 rounded right-0 left-0 bottom-0 top-0",
      tag: "ml-[8px] px-[4px] bg-gray-200/30 rounded text-gray-700 text-[12px] leading-[16px]",
      tagActive: "ml-[8px] px-[4px] bg-gray-200/30 rounded text-black text-[12px] leading-[16px]"
    },
    icon: {
      size: "16",
      // <wind-keep fillColor="transparent"/>
      fillColor: "transparent"
    }
  },
  "indigo-light": {
    classes: {
      wrapper: "p-[4px] inline-flex gap-[4px] rounded border border-gray-100 bg-white text-gray-700 relative",
      button: "flex items-center px-[12px] h-[24px] leading-[20px] text-[14px] rounded font-medium whitespace-nowrap bg-transparent border-0",
      active: "text-indigo-500 relative z-20",
      activeStatic: "",
      inActive: "hover:bg-gray-50",
      activeMarker: "absolute bottom-[4px] top-[4px] rounded duration-300 ease-in-out",
      activeMarkerColor: "z-10 bg-indigo-100",
      activeMarkerBlender: "z-30 mix-blend-overlay pointer-events-none",
      activeMarkerStatic: "bg-gray-800 absolute -z-10 rounded right-0 left-0 bottom-0 top-0",
      tag: "ml-[8px] px-[4px] bg-indigo-200/30 rounded text-gray-700 text-[12px] leading-[16px]",
      tagActive: "ml-[8px] px-[4px] bg-indigo-300/30 rounded text-indigo-500 text-[12px] leading-[16px]"
    },
    icon: {
      size: "16",
      // <wind-keep fillColor="transparent"/>
      fillColor: "transparent"
    }
  },
  "dark-small": {
    classes: {
      wrapper: "p-[4px] inline-flex gap-[4px] rounded border border-gray-900 bg-gray-1000 text-gray-400 relative",
      button: "flex items-center px-[8px] h-[20px] leading-[16px] text-[12px] rounded font-medium whitespace-nowrap bg-transparent border-0",
      active: "text-white relative z-20",
      activeStatic: "",
      inActive: "hover:bg-gray-900",
      activeMarker: "absolute bottom-[4px] top-[4px] rounded duration-300 ease-in-out",
      activeMarkerColor: "z-10 bg-gray-800",
      activeMarkerBlender: "z-30 mix-blend-overlay pointer-events-none",
      activeMarkerStatic: "bg-gray-800 absolute -z-10 rounded right-0 left-0 bottom-0 top-0",
      tag: "ml-[8px] px-[4px] bg-gray-200/30 rounded text-gray-200 text-[12px] leading-[16px]",
      tagActive: ""
    },
    icon: {
      size: "16",
      // <wind-keep fillColor="transparent"/>
      fillColor: "transparent"
    }
  },
  "dark-large": {
    classes: {
      wrapper: "p-[4px] inline-flex gap-[4px] rounded border border-gray-900 bg-gray-1000 text-gray-400 relative",
      button: "flex items-center px-[12px] h-[24px] leading-[20px] text-[14px] rounded font-medium whitespace-nowrap bg-transparent border-0",
      active: "text-white relative z-20",
      activeStatic: "",
      inActive: "hover:bg-gray-900",
      activeMarker: "absolute bottom-[4px] top-[4px] rounded duration-300 ease-in-out",
      activeMarkerColor: "z-10 bg-gray-800",
      activeMarkerBlender: "z-30 mix-blend-overlay pointer-events-none",
      activeMarkerStatic: "bg-gray-800 absolute -z-10 rounded right-0 left-0 bottom-0 top-0",
      tag: "ml-[8px] px-[4px] bg-gray-200/30 rounded text-gray-200 text-[12px] leading-[16px]",
      tagActive: ""
    },
    icon: {
      size: "16",
      // <wind-keep fillColor="transparent"/>
      fillColor: "transparent"
    }
  },
  "underline-small": {
    classes: {
      wrapper: "py-[4px] flex gap-[8px] border-0 border-b border-solid border-gray-100 text-gray-700 relative",
      button: "flex items-center px-[12px] h-[24px] leading-[20px] text-[14px] rounded font-medium whitespace-nowrap hocus:no-underline relative bg-transparent border-0",
      active: "text-indigo-500 z-20",
      activeStatic: "relative",
      inActive: "text-gray-700 hocus:no-underline hocus:text-gray-700 before:transition-colors before:duration-300 before:absolute hover:before:bg-gray-200 before:bottom-[-6.5px] before:h-[4px] before:left-0 before:right-0 before:rounded-full",
      activeMarker: "absolute bottom-[-2.5px] h-[4px] rounded-full z-10 duration-300 ease-in-out",
      activeMarkerColor: "bg-indigo-500",
      activeMarkerBlender: "hidden",
      activeMarkerStatic: "absolute bg-indigo-500 rounded-full right-0 left-0 bottom-[-6.5px] h-[4px]",
      tag: "ml-[8px] px-[4px] bg-gray-200/20 rounded text-gray-500 text-[12px] leading-[16px]",
      tagActive: ""
    },
    icon: {
      size: "16",
      // <wind-keep fillColor="transparent"/>
      fillColor: "transparent"
    }
  },
  "underline-center": {
    classes: {
      wrapper: "py-[4px] flex justify-center items-center h-[64px] gap-[32px] text-gray-700 relative",
      subWrapper: "absolute bottom-0 left-0 right-0 block h-[1px] rounded-full bg-gradient-to-r from-transparent via-gray-100 via-gray-100 via-gray-100 to-transparent",
      button: "flex items-center px-[12px] h-full leading-[20px] text-[14px] rounded font-medium whitespace-nowrap hocus:no-underline relative bg-transparent border-0",
      active: "text-indigo-500 z-20",
      activeStatic: "relative",
      inActive: "text-gray-700 hocus:no-underline hocus:text-gray-700 before:transition-colors before:duration-300 before:absolute hover:before:bg-gray-200 before:bottom-[-5.5px] before:h-[4px] before:left-0 before:right-0 before:rounded-full",
      activeMarker: "absolute bottom-[-1.5px] h-[4px] rounded-full z-10 duration-300 ease-in-out",
      activeMarkerColor: "bg-indigo-500",
      activeMarkerBlender: "hidden",
      activeMarkerStatic: "absolute bg-indigo-500 rounded-full right-0 left-0 bottom-[-6.5px] h-[4px]",
      tag: "ml-[8px] px-[4px] bg-indigo-300/20 rounded text-gray-500 text-[12px] leading-[16px]",
      tagActive: ""
    },
    icon: {
      size: "16",
      // <wind-keep fillColor="transparent"/>
      fillColor: "transparent"
    }
  },
  "underline-large": {
    classes: {
      wrapper: "py-[4px] flex gap-[8px] border-0 border-b border-solid border-gray-100 text-gray-700 relative",
      button: "flex items-center px-[12px] h-[32px] leading-[24px] text-[16px] rounded font-medium whitespace-nowrap relative hocus:no-underline bg-transparent border-0",
      active: "text-indigo-500 z-20",
      activeStatic: "relative",
      inActive: "text-gray-700 hocus:text-gray-700 before:transition-colors before:duration-300 before:absolute hover:before:bg-gray-200 before:bottom-[-6.5px] before:h-[4px] before:left-0 before:right-0 before:rounded-full",
      activeMarker: "absolute bottom-[-2.5px] h-[4px] rounded-full z-10 duration-300 ease-in-out",
      activeMarkerColor: "bg-indigo-500",
      activeMarkerBlender: "hidden",
      activeMarkerStatic: "absolute bg-indigo-500 rounded-full right-0 left-0 bottom-[-6.5px] h-[4px]",
      tag: "ml-[8px] px-[4px] bg-gray-100/50 rounded text-gray-500",
      tagActive: ""
    },
    icon: {
      size: "24",
      // <wind-keep fillColor="transparent"/>
      fillColor: "transparent"
    }
  }
}, Z = /* @__PURE__ */ F({
  __name: "Tabs",
  props: {
    tabs: {},
    activeId: {},
    variant: { default: "default" }
  },
  emits: ["switch", "update:activeId"],
  setup(f, { emit: k }) {
    var $;
    const t = f, w = C(), M = k, a = C(t.activeId ?? (($ = t.tabs.find((i) => i.active)) == null ? void 0 : $.id));
    T(
      () => t.activeId,
      (i) => {
        a.value = i;
      }
    );
    const n = C();
    function I() {
      var o;
      const i = t.tabs.findIndex((e) => e.id === a.value);
      if (i > -1) {
        const e = (o = w.value) == null ? void 0 : o[i];
        e && (n.value = {
          ...n.value,
          left: `${e.offsetLeft}px`,
          width: `${e.offsetWidth}px`
        });
      }
    }
    const B = X(I, 100);
    D(() => {
      T(
        a,
        () => {
          I();
        },
        { immediate: !0 }
      ), q(() => {
        n.value = {
          ...n.value,
          transitionProperty: "left, width"
        };
      });
    }), D(() => {
      window.addEventListener("resize", B);
    }), G(() => {
      window.removeEventListener("resize", B);
    });
    function E(i) {
      var p, u;
      const o = t.tabs.findIndex((s) => s.id === a.value) + i, e = o < 0 ? t.tabs.length - 1 : o >= t.tabs.length ? 0 : o, d = new j();
      M("switch", t.tabs[e], d), !d.defaultPrevented && (a.value = t.tabs[e].id, (u = (p = w.value) == null ? void 0 : p[e]) == null || u.focus(), M("update:activeId", t.tabs[e].id));
    }
    const r = K(() => t.variant in g ? g[t.variant].classes : g.default.classes), P = K(() => t.variant in g ? g[t.variant].icon : g.default.icon);
    return (i, o) => (l(), x("div", {
      role: "tablist",
      class: c(r.value.wrapper)
    }, [
      "subWrapper" in r.value ? (l(), x("div", {
        key: 0,
        class: c(r.value.subWrapper)
      }, null, 2)) : v("", !0),
      (l(!0), x(L, null, H(i.tabs, ({
        id: e,
        href: d,
        label: p,
        tag: u,
        icon: s,
        iconBefore: m,
        iconAfter: h,
        ...z
      }) => (l(), S(A(d ? "a" : "button"), y({
        id: e,
        key: e,
        ref_for: !0,
        ref_key: "$tab",
        ref: w,
        href: d,
        role: "tab",
        tabindex: e === a.value ? void 0 : -1,
        "aria-selected": e === a.value,
        class: [
          r.value.button,
          {
            [r.value.activeStatic]: e === a.value && !n.value,
            [r.value.active]: e === a.value,
            [r.value.inActive]: e !== a.value
          }
        ]
      }, z, {
        onClick: (b) => {
          if (b.ctrlKey || b.metaKey)
            return;
          b.preventDefault();
          const _ = new (J(j))();
          M(
            "switch",
            {
              id: e,
              href: d,
              label: p,
              tag: u,
              icon: s,
              iconBefore: m,
              iconAfter: h,
              ...z
            },
            _
          ), !_.defaultPrevented && (a.value = e);
        },
        onKeyup: [
          o[0] || (o[0] = V((b) => E(-1), ["left"])),
          o[1] || (o[1] = V((b) => E(1), ["right"]))
        ]
      }), {
        default: O(() => [
          Q(i.$slots, "tab", y({ ref_for: !0 }, {
            id: e,
            href: d,
            label: p,
            tag: u,
            icon: s,
            iconBefore: m,
            iconAfter: h,
            ...z
          }), () => [
            m ?? s ? (l(), S(A(m ?? s), y({
              key: 0,
              ref_for: !0
            }, P.value, { class: "mr-[8px]" }), null, 16)) : v("", !0),
            R(" " + W(p) + " ", 1),
            u ? (l(), x("div", {
              key: 1,
              class: c(
                e === a.value && r.value.tagActive.length ? r.value.tagActive : r.value.tag
              )
            }, W(u), 3)) : v("", !0),
            h ? (l(), S(A(h), y({
              key: 2,
              ref_for: !0
            }, P.value, { class: "ml-[8px]" }), null, 16)) : v("", !0)
          ]),
          e === a.value && !n.value ? (l(), x("div", {
            key: 0,
            class: c(r.value.activeMarkerStatic)
          }, null, 2)) : v("", !0)
        ]),
        _: 2
      }, 1040, ["id", "href", "tabindex", "aria-selected", "class", "onClick"]))), 128)),
      n.value ? (l(), x(L, { key: 1 }, [
        N("div", {
          class: c([r.value.activeMarker, r.value.activeMarkerColor]),
          style: U(n.value)
        }, null, 6),
        N("div", {
          class: c([r.value.activeMarker, r.value.activeMarkerBlender]),
          style: U(n.value)
        }, null, 6)
      ], 64)) : v("", !0)
    ], 2));
  }
});
export {
  Z as default
};
//# sourceMappingURL=index.es.mjs.map

/* <wind-keep class="resize mr-[8px] ml-[8px]"> */
